
export default class PaysService{
    constructor(axios, snackbar) {
        this.axios = axios;
        this.snackbar = snackbar;
    }

    autocomplete(nom) {
        return this.axios
            .get("/api/pays/autocomplete", { params: { nom } })
            .catch(this.snackbar.catch())
            .then(response => response.data);
    }
}
